export function abreviateName(string: string) {
    if (!string) return string;
    const names = string.split(' ');
    const fisrtName = names.shift();
    const lastName = names.pop();
    const abreviate = names.reduce((arr: any, str: string) => {
        const letraGrande = str.match(/[A-ZÖÄÅÀÁÂÃÌÍÒÓÉÊÚ]/);
        if (!letraGrande) return arr;
        return arr.concat(`${letraGrande[0]}.`);
    }, []);

    return [fisrtName, ...abreviate, lastName].join(' ');
}

export function toQueryParams(obj: Record<string, any>): string {
    const params = new URLSearchParams();
    Object.entries(obj).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            params.append(key, String(value));
        }
    });
    return params.toString();
}
